import api from 'Application/api/api';

const createActivity = (signal, values) =>
	api.post('/activity-templates', values, {
		signal,
	});

export default createActivity;
